"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);
  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);
    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;
    if (getter === undefined) {
      return undefined;
    }
    return getter.call(receiver);
  }
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports._setLoading = _setLoading;
var _events = require("events");
var _events2 = _interopRequireDefault(_events);
var _simpleLoadScript = require("simple-load-script");
var _simpleLoadScript2 = _interopRequireDefault(_simpleLoadScript);
var _whenConditional = require("when-conditional");
var _whenConditional2 = _interopRequireDefault(_whenConditional);
var _queue2 = require("queue");
var _queue3 = _interopRequireDefault(_queue2);
var _canUseDom = require("can-use-dom");
var _canUseDom2 = _interopRequireDefault(_canUseDom);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _queue = void 0;
function _createQueue() {
  if (!_queue) _queue = (0, _queue3.default)();
}
var _loading = void 0;
function _setLoading(isLoading) {
  _loading = isLoading;
}
function guard(options) {
  if ((typeof options === "undefined" ? "undefined" : _typeof(options)) !== "object") throw new TypeError("options must be an object.");
  if (options.universalDataObject && _typeof(options.universalDataObject) !== "object") throw new TypeError("universalDataObject must be an object.");
  if (typeof options.account !== "string") throw new TypeError("account option is required and must be of type string.");
  if (typeof options.profile !== "string") throw new TypeError("profile option is required and must be of type string.");
  if (typeof options.environment !== "string") throw new TypeError("environment option is required and must be of type string.");
  if (options.async && typeof options.async !== "boolean") throw new TypeError("async option must be of type boolean.");
  if (options.manualPageView && typeof options.manualPageView !== "boolean") throw new TypeError("manualPageView option must be of type boolean.");
  if (options.lazyLoad && typeof options.lazyLoad !== "boolean") throw new TypeError("lazyLoad option must be of type boolean.");
  if (options.debug && typeof options.debug !== "boolean") throw new TypeError("debug option must be of type boolean.");
  if (options.loadTimeout && typeof options.loadTimeout !== "number") throw new TypeError("loadTimeout option must be of type number.");
  if (options.loadScriptInBody && typeof options.loadScriptInBody !== "boolean") throw new TypeError("loadScriptInBody option must be of type boolean.");
}
function debug(options, message) {
  if (options.isDebug) console.log(message); // eslint-disable-line no-console
}

/**
  * Checked on the window object whether or not the tag has been loaded.
  * @returns boolean
  */
function isLoaded() {
  /* Need to check that window is truthy 
  * so clean up of tests don't remove it
  * before we potentially check it afterwards.
  */
  return window && Boolean(window.utag);
}

/**
 * Calls a method on utag, appending to the queue when the tag has not completed loading.
 * @param {string} method
 * @param {{}} params
 * @returns Promise
 */
function utagProxy(options, method, params) {
  debug(options, "_callUTag(" + method + "), " + JSON.stringify(params));
  if (!isLoaded() || _loading) {
    debug(options, "Queueing utag call.");
    // queue
    _queue.push(function (callback) {
      utagProxy(options, method, params).then(function () {
        callback();
      });
    });
    return Promise.resolve();
  }
  return new Promise(function (resolve) {
    debug(options, "Executing method \"" + method + "\" on window.utag");
    window.utag[method](params, function () {
      resolve();
    });
  });
}

/**
 * Loads the tag, making sure it only loads once.
 * Utilises the timeout option to prevent waiting forever.
 * @returns Promise
 */
function load(options, emitReady) {
  if (!_canUseDom2.default) {
    debug(options, "Cannot load the tealium universal tag when it appears that the environment cannot currently use the DOM.");
    return Promise.resolve();
  }
  debug(options, "Loading utag.");
  if (_loading || isLoaded()) {
    debug(options, "utag is loading or already loaded.");
    return Promise.resolve();
  }
  _loading = true;
  debug(options, "Setting up config on window.");
  // setup UDO on window object
  window.utag_data = window.utag_data || options.universalDataObject; // eslint-disable-line camelcase
  // setup config options on window object applying existing if any
  window.utag_cfg_ovrd = window.utag_cfg_ovrd || {}; // eslint-disable-line camelcase
  window.utag_cfg_ovrd.noview = options.manualPageView;
  var tag = options.async ? options.tags.async : options.tags.sync;
  debug(options, "Loading tag from url \"" + tag + "\".");

  // add scripts tag to dom

  (0, _simpleLoadScript2.default)(tag, {
    attrs: {
      async: options.async,
      id: "tealium-universal-tag"
    },
    inBody: options.loadScriptInBody
  }).then(function () {
    debug(options, "Script tag added to dom.");
    return new Promise(function (resolve, reject) {
      debug(options, "Waiting for window.utag to exist.");
      var whenLoaded = null;
      var loadTimeout = setTimeout(function () {
        var timedOutMessage = "Timed out waiting for window.utag to exist after " + options.loadTimeout + "ms";
        debug(options, timedOutMessage);
        if (whenLoaded) {
          debug(options, "Clearing whenObj");
          whenLoaded.clear();
        }
        _loading = false;
        reject(new Error(timedOutMessage));
      }, options.loadTimeout);

      // Wait for utag to exist on the window object
      whenLoaded = (0, _whenConditional2.default)(isLoaded, function () {
        debug(options, "window.utag exists.");
        _loading = false;
        if (loadTimeout) {
          debug(options, "Clearing loadTimeout timeout. Id: " + loadTimeout);
          clearTimeout(loadTimeout);
        }
        _queue.start();
        emitReady();
        resolve();
      });
    });
  }).catch(function (err) {
    var out = console.error ? console.error : console.log; // eslint-disable-line no-console
    out("Tealium universal tag failed to initialize.", err);
    // setTimeout(this.load, 1000); // should we implement retry logic
    _loading = false;
  });
  debug(options, "Return with resolved promise.");
  return Promise.resolve();
}
var TealiumUniversalTag = function (_EventEmitter) {
  _inherits(TealiumUniversalTag, _EventEmitter);

  /**
    * @constructor
    * @param {{}} options - The tealium universal tag options.
    * @param {string} options.environment - The tealium environent to send events to.
    * @param {string} options.account - The tealium account to send events to.
    * @param {string} options.profile - The tealium profile to send events to.
    * @param {object} options.universalDataObject - The defined universal data object that acts as a data contract to tealium.
    * @param {boolean} options.async - Whether or not to load the async tag into the dom.
    * @param {boolean} options.manualPageView - Indicate whether tealium should automatically fire page view events or not. This option might also be called "supress initial page view" which is ideal for SPAs
    * @param {number}  options.loadTimeout - The timeout in milliseconds to wait until we timeout trying to load the tealium tag.
    * @param {boolean} options.lazyLoad - Whether or not to lazyload the tealium tag into the DOM. If true, loading of the tealium tag is delayed until the first event is recieved. If false, loading of the tealium tag is immediate.
    * @param {boolean} options.loadScriptInBody - True appends the script to the <body> element, otherwise append to <head>.
    * @param {boolean} options.debug - True enabled debugging which outputs detailed information to the console.
    */
  function TealiumUniversalTag(ops) {
    _classCallCheck(this, TealiumUniversalTag);
    _createQueue();
    var _this = _possibleConstructorReturn(this, (TealiumUniversalTag.__proto__ || Object.getPrototypeOf(TealiumUniversalTag)).call(this));
    guard(ops);
    _this.options = {
      universalDataObject: ops.universalDataObject || {},
      account: ops.account,
      profile: ops.profile,
      environment: ops.environment,
      async: ops.async || true,
      manualPageView: ops.manualPageView || false,
      lazyLoad: ops.lazyLoad || false,
      isDebug: ops.debug || false,
      loadTimeout: ops.loadTimeout || 5 * 1000,
      // 5 secs
      loadScriptInBody: ops.loadScriptInBody || true,
      tags: {
        async: "//tags.tiqcdn.com/utag/" + ops.account + "/" + ops.profile + "/" + ops.environment + "/utag.js",
        sync: "//tags.tiqcdn.com/utag/" + ops.account + "/" + ops.profile + "/" + ops.environment + "/utag.sync.js"
      }
    };
    _this._emitReady = function () {
      _get(TealiumUniversalTag.prototype.__proto__ || Object.getPrototypeOf(TealiumUniversalTag.prototype), "emit", _this).call(_this, "ready");
    };
    debug.bind(_this)("TealiumUniversalTag initialized with options: " + JSON.stringify(_this.options));
    if (!_this.options.lazyLoad) {
      debug(_this.options, "Lazy loading disabled. Loading script immediately.");
      load(_this.options, _this._emitReady);
    }
    return _this;
  }

  /**
     * Maps to the link method on utag.
     * @param {string} eventName
     * @param {{}} params
     */

  _createClass(TealiumUniversalTag, [{
    key: "track",
    value: function track(eventName) {
      var _this2 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof eventName !== "string") {
        return Promise.reject(new TypeError("eventName is required and must be of type string."));
      }
      debug(this.options, "track(" + eventName + ", " + JSON.stringify(params) + ")");
      return load(this.options, this._emitReady).then(function () {
        var utagData = Object.assign(params, {
          'event_name': eventName
        });
        return utagProxy(_this2.options, "link", utagData);
      });
    }

    /**
       * Maps to the view method on utag.
       * @param {string} eventName - Only for compatiblility reasons with react-metrics. Ignored.
       * @param {{}} params
    */
  }, {
    key: "pageView",
    value: function pageView(eventName, params) {
      var _this3 = this;
      debug(this.options, "pageView(" + JSON.stringify(params) + ")");
      return load(this.options, this._emitReady).then(function () {
        return utagProxy(_this3.options, "view", params);
      });
    }
  }]);
  return TealiumUniversalTag;
}(_events2.default);
exports.default = TealiumUniversalTag;